
<app-nav-admin--menu></app-nav-admin--menu>
<div class="configContent">
<h1 class="configTitle">Users</h1>
<mat-toolbar>
  <mat-toolbar-row>
    <span class="toolbar-spacer"></span>
    <button class="toolbar-button"
            (click)="addUser()"
            matTooltip="Add New">
      <mat-icon>add_circle_outline</mat-icon>
      <div class="column-settings-title">Add New</div>
    </button>
    <button class="toolbar-button"
            (click)="export()"
            matTooltip="Export">
      <mat-icon>arrow_circle_down</mat-icon>
      <div class="column-settings-title">Export</div>
    </button>
    <mat-form-field class="column-settings-holder">
      <!--<mat-label>Columns</mat-label>-->
      <button class="toolbar-button"
              matTooltip="Columns">
        <mat-icon>view_column</mat-icon>
        <div class="column-settings-title">Columns</div>
        <mat-select multiple class="column-filter" [formControl]="selectedColumns">
          <mat-option *ngFor="let column of columns" (click)="toggleColumn(column.name)" [value]="column.name">{{column.text}}</mat-option>
        </mat-select>
      </button>
    </mat-form-field>
  </mat-toolbar-row>
</mat-toolbar>
<table class="table">
  <thead>
    <tr>
      <th class="{{columns[0].classname}} userEmail" scope="col">{{getColumnName('email')}}</th>
      <th class="{{columns[1].classname}}" scope="col">{{getColumnName('firstName')}}</th>
      <th class="{{columns[2].classname}}" scope="col">{{getColumnName('lastName')}}</th>
      <th class="{{columns[3].classname}}" scope="col">{{getColumnName('orgName')}}</th>
      <th class="{{columns[4].classname}}" scope="col">{{getColumnName('emailConfirmed')}}</th>
      <th class="{{columns[5].classname}}" scope="col">{{getColumnName('status')}}</th>
      <th class="{{columns[6].classname}}" scope="col">{{getColumnName('role')}}</th>
      <th class="{{columns[7].classname}}" scope="col">{{getColumnName('lastLoginDate')}}</th>
      <th scope="col">Actions</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let user of users; index as i">
      <td class="{{columns[0].classname}} emailColumn">{{user.email}}</td>
      <td class="{{columns[1].classname}}">{{user.firstName}}</td>
      <td class="{{columns[2].classname}}">{{user.lastName}}</td>
      <td class="{{columns[3].classname}}">{{user.orgName}}</td>
      <td class="{{columns[4].classname}}">{{user.emailConfirmed}}</td>
      <td class="{{columns[5].classname}}">{{user.status}}</td>
      <td class="{{columns[6].classname}}">{{user.role}}</td>
      <td class="{{columns[7].classname}}">{{user.lastLoginDate}}</td>
      <td>
        <button mat-icon-button (click)="editUser(i)"><mat-icon>edit</mat-icon></button>
        <button mat-icon-button (click)="deleteUser(i)"><mat-icon>delete</mat-icon></button>
      </td>
    </tr>
    <!--<tr>
      <td></td>
      <td></td>
      <td>-->
        <!--<button mat-icon-button (click)="addUser()"><mat-icon>add</mat-icon></button>-->
      <!--</td>
    </tr>-->
  </tbody>
</table>
<hr />

<div class="mb-5 buttonConfig">
  <button mat-raised-button class="me-2" (click)="save()" [disabled]="!dirty">Save</button>
  <button mat-raised-button (click)="discard()" [disabled]="!dirty">Discard Changes</button>
</div>
  </div>
<footer>
  <patempoFooter></patempoFooter>
</footer>
